import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { styled } from '@mui/system';
import { Tooltip } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import IconButton from '@mui/material/IconButton';
import { getDeeplink } from '#action/shipment/deeplink';
import { SUCCESS } from '#action/types';
import { writeToClipboard } from '#helper';

const StyledLinkIcon = styled(LinkIcon)({
  color: '#000'
});

const DeepLinkButton = ({ shipmentId }) => {
  const dispatch = useDispatch();
  const account = useSelector(s => s.account, shallowEqual);

  const handleDeeplinkClick = async e => {
    e.stopPropagation();
    const { success, token } = await dispatch(getDeeplink(shipmentId));
    if (success) {
      writeToClipboard(`${window.location.origin}/link/shipment/${token}?system=${account.measurementSystem}`);
      dispatch({
        type: SUCCESS,
        payload: {
          message: 'Link copied to clipboard'
        }
      });
    }
  };

  return (
    <Tooltip title="Copy deeplink">
      <IconButton onClick={e => handleDeeplinkClick(e)}>
        <StyledLinkIcon />
      </IconButton>
    </Tooltip>
  );
};

export default DeepLinkButton;
